module.exports = __webpack_public_path__ + "static/lawyers-07bbedffe04036c70ac33afce7bb80aa.jpg";